import { MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledRelatedPosts = styled.div`
  ${MediaQueries.mbUp} {
    padding: 0.5rem 0;
  }
  &[data-show-full='true'] {
    padding: 0;
  }
`

export const StyledLink = styled.a`
  display: block;
  margin-bottom: 1rem;
  ${MediaQueries.mbDown} {
    margin-bottom: 0.5rem;
  }
  .related-post {
    color: ${(props: ThemeProps) => props.theme.mbColors.cobalt};
    pointer-events: none;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
    text-decoration: underline;

    ${MediaQueries.mbDown} {
      font-size: 14px;
      line-height: 22px;
    }
  }
`

export const StyledPostsContainer = styled.div`
  margin: 1rem 0 0;

  .amp-article-card .avatar {
    margin-right: 16px;
  }

  &[data-is-amp='true'] {
    margin-bottom: 52px;
  }

  ${MediaQueries.mbDown} {
    margin: 0.5rem 0 0;
  }
  &[data-show-full='true'] {
    margin: 0;
    ${MediaQueries.mbUp} {
      .related-article-card[data-size='md'] {
        padding-top: 0.5rem;
      }
    }
  }

  .content .author {
    flex: 1;
    .avatar {
      width: 32px;
      height: 32px;
    }
  }
`
export const StyledPostWrapper = styled.div`
  padding: 0;
  cursor: pointer;
  .content .inner-content .text {
    -webkit-line-clamp: 2;
  }
`

export const StyledMiddleRelatedWrapperInner = styled.div`
  width: 100%;
  padding: 1rem 0;
  padding: 1rem 1rem 0;
  ${MediaQueries.mbUp} {
    padding: 1rem 0 0;
  }
  background: white;
`
export const StyledMiddleRelatedWrapperOuter = styled.div`
  width: 100%;
  ${MediaQueries.mbDown} {
    width: calc(100% + 2rem);
    margin-right: -1rem;
    margin-left: -1rem;
  }
  padding: 1rem 0;
  padding: 0.5rem 0;
  background: ${(props: ThemeProps) => props.theme.colors.neutral50};
`
